import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/router";

// 기존 import 구문 제거하시고 아래 2줄만 추가하세요
import "./styles/global_admin.scss";
import "./styles/contents_admin.scss";

// 아래 로직이 모든 파일에 공통으로 적용됩니다.
document.body.classList.add("type-" + process.env.REACT_APP_STYLE || "jayeon");


if (typeof document !== "undefined") {
  document.documentElement.lang = window.location.pathname.startsWith("/cn") ? "zh-CN" : "ko";
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);
